import { createFileRoute, Outlet } from "@tanstack/solid-router";

export const Route = createFileRoute("/_dashboard/dashboard/documents")({
  staticData: {
    breadcrumb: "Documents",
  },
  component: () => <Outlet />,
});
